export type ToastVariant = "success" | "error" | "warning" | "info";

export const showGlobalToast = (message: string, variant: ToastVariant = "info") => {
  window.dispatchEvent(new CustomEvent("g:toast", { detail: { message, variant } }));
};

let _confirmResolve: ((ok: boolean) => void) | null = null;

export const showGlobalConfirm = (title: string, message: string): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    _confirmResolve = resolve;
    window.dispatchEvent(new CustomEvent("g:confirm", { detail: { title, message } }));
  });
};

export const _resolveConfirm = (ok: boolean) => {
  const resolve = _confirmResolve;
  _confirmResolve = null;
  resolve?.(ok);
};
